import React from "react";
import { useNavigate } from "react-router-dom";
import './Yourlevel.css';

const YourLevel = ({ updateUserData }) => {
    const navigate = useNavigate();

    const handleLevelClick = (level) => {
        updateUserData({ yourLevel: level });
        navigate('/bodylevel');
    };

    const levelDescriptions = {
        Novice: "A workout is a planned session of physical activity aimed at improving fitness, strength, or overall health. It includes cardio, and flexibility exercises",
        Beginner: "A beginner is someone who is starting their fitness journey and learning the basics of exercise.",
        Intermediate: "An intermediate level indicates a moderate understanding of workouts and a consistent exercise routine.",
        Advanced: "An advanced level represents a high level of fitness, with complex workouts and techniques."
    };

    return (
        <div className="b1">
            <div className="level-title">Your Level</div>
            <div className="y1">
            <div className="level-container">
                {['Novice', 'Beginner', 'Intermediate', 'Advanced'].map(level => (
                    <div key={level} className="level-box" onClick={() => handleLevelClick(level)}>
                        <div className="level-header">{level}</div>
                        <div className="level-description">{levelDescriptions[level]}</div>
                    </div>
                ))}
            </div>
            </div>
            <button onClick={() => navigate('/fitnessgoal')} className="level-button back-button">Back</button>
        </div>
    );
};

export default YourLevel;
